import CsvTableWidget, { CSVTableMetadata } from '@/components/CsvTableWidget';
import FilesWidget from '@/components/FilesWidget';
import PremiumWidgetDenied from '@/features/Dashboard/components/PremiumWidgetDenied';
import useIsPremiumAccess from '@/hooks/useIsPremiumAccess';
import ChartsBlock from '@/pages/Markets/MarketsComponents/Chart';
import CommoditiesTable from '@/pages/Markets/MarketsComponents/CommoditiesTable';
import { Feed } from '@/pages/Markets/MarketsComponents/Feed';
import { FeedFilters } from '@/pages/Markets/MarketsComponents/Feed/api/fetchFeedData';
import GraphStatic from '@/pages/Markets/MarketsComponents/GraphStatic';
import { LightModeProvider } from '@/pages/Markets/MarketsComponents/LightMode/contexts/LightModeContext';
import MiniTablesContainer from '@/pages/Markets/MarketsComponents/MiniTablesContainer';
import { BaseTabType } from '@/slices/marketsSlice';

export const MarketWidget = ({ tab }: { tab: BaseTabType }) => {
  const isPremiumAccessGranted = useIsPremiumAccess();

  switch (tab.type) {
    case 'table':
      return (
        <CommoditiesTable
          key={tab.id}
          sections={tab.sections}
        />
      );
    case 'graph':
      if (!isPremiumAccessGranted) {
        return <PremiumWidgetDenied />;
      }
      if (tab?.metadata?.graphType === 'static') {
        return (
          <GraphStatic
            key={tab.id}
            metadata={tab.metadata}
          />
        );
      }
      return (
        <LightModeProvider>
          <ChartsBlock
            key={tab.id}
            tab={tab}
          />
        </LightModeProvider>
      );

    case 'feed':
      return (
        <Feed
          key={tab.id}
          metadata={tab.metadata as FeedFilters}
        />
      );

    case 'minitable':
      return <MiniTablesContainer tables={tab.tables} />;
    case 'csvtable':
      return (
        <CsvTableWidget
          fileName={tab.fileName}
          groupName={tab.groupName}
          metadata={tab.metadata as CSVTableMetadata}
        />
      );
    case 'file_list':
      return (
        <FilesWidget
          downloadable={tab.metadata?.downloadable as any}
          groupName={tab.groupName as any}
          size={tab.size as any}
        />
      );
    default:
      return null;
  }
};
